<template>
  <f7-page hide-navbar-on-scroll>
    <f7-navbar :title="$t('tc-title-label')" color="black"  back-link="înapoi">
      <f7-nav-right>
         <img :src=$session_logo />
      </f7-nav-right>
    </f7-navbar>
    <f7-toolbar bottom>
      <small>{{ $t('copyright') }}</small>
    </f7-toolbar>

    <f7-block-title>{{ $t('tc-title-label') }}</f7-block-title>

    <f7-block strong>
      {{ $t('tc-intro_line_1') }} <strong>{{ valid_from }}</strong>. 
      {{ $t('tc-intro_line_2') }}
    </f7-block>

    <f7-block>
      <Markdown :source="markdown" />
    </f7-block>

  </f7-page>
</template>

<script>
  import Markdown from 'vue3-markdown-it';
  import { useStore, f7 } from 'framework7-vue';

  export default {
    components: {
      Markdown,
    },
    props: {
      markdown: String,
      valid_from: String,
    },
  }
</script>
